import { render, staticRenderFns } from "./prop_map.vue?vue&type=template&id=60678157&scoped=true&"
import script from "./prop_map.vue?vue&type=script&lang=js&"
export * from "./prop_map.vue?vue&type=script&lang=js&"
import style0 from "./prop_map.vue?vue&type=style&index=0&id=60678157&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60678157",
  null
  
)

export default component.exports